<nz-table
  #nzTable
  class="v4-layout-list"
  [nzFrontPagination]="false"
  [nzData]="listOfTask"
  [nzTotal]="total"
  [(nzPageIndex)]="page"
  [nzPageSize]="pageSize"
  nzPaginationType="small"
  [nzShowTotal]="totalTpl"
  (nzPageIndexChange)="onPageChange.emit($event)"
>
  <thead>
    <tr>
      <th>{{ "task.word.type.text" | translate }}</th>
      <th>{{ "task.word.assignee" | translate }}</th>
      <th>{{ "task.word.property" | translate }}</th>
      <th>{{ "task.word.time" | translate }}</th>
      <th>{{ "task.word.fee" | translate }}</th>
      <th>{{ "task.filter.status" | translate }}</th>
      <th>{{ "task.word.description" | translate }}</th>
      <th>{{ "task.list.feedback" | translate }}</th>
    </tr>
  </thead>
  <tbody class="v4-layout-list-body">
    <tr class="cursor-pointer" *ngFor="let data of nzTable.data" (click)="onClickTask.emit(data)">
      <td>
        <span>{{ getType(data?.type) }}</span>
      </td>
      <td>
        <span>{{ data?.staff?.name || "-" }}</span>
      </td>
      <td>
        <span>
          {{ data?.house?.title_alias || "-" }}
        </span>
      </td>
      <td>
        <span>{{ data?.expected_format?.short }}</span>
      </td>
      <td>
        <span> {{ data?.currency_type | currencyToSymbol }}{{ data?.fee }} </span>
      </td>
      <td>
        <span class="status" [style.background-color]="statusColorMap[data.status]">{{ getStatus(data?.status) }}</span>
      </td>
      <td>
        <span>{{ data?.note || "-" }}</span>
      </td>
      <td>
        <div class="flex flex-row items-center">
          <div
            *ngIf="data?.photos?.length"
            class="mr-2 text-primary cursor-pointer"
            (click)="$event.stopPropagation(); showCredentials(data?.photos)"
          >
            <img src="/assets/icon/attachment.png" class="w-[13px] h-[13px]" />
            <span>{{ data?.photos?.length }}</span>
          </div>
          <span>{{ data.feedback || "-" }}</span>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>
<ng-template #totalTpl>
  {{ "component-page_html_总数" | translate : { number: total } }}
  <!-- {{ total }} items -->
</ng-template>
